import type { Lang } from "@shared/types";
import { UI_LANGS, useI18n } from "../i18n";
import { play } from "../lib/sfx";

export function LangSwitch({ compact }: { compact?: boolean }) {
  const { lang, setLang, d } = useI18n();
  return (
    <div className="inline-flex rounded-full bg-ground-3 p-1" role="radiogroup" aria-label={d.prefs.language}>
      {UI_LANGS.map((l: Lang) => (
        <button
          key={l}
          role="radio"
          aria-checked={l === lang}
          className={`rounded-full px-3 py-1.5 text-sm font-extrabold transition-colors ${l === lang ? "bg-ink text-ground" : "text-ink-2 hover:text-ink"}`}
          onClick={() => {
            play("tap");
            setLang(l);
          }}
        >
          {compact ? d.common.langShort[l] : d.common.lang[l]}
        </button>
      ))}
    </div>
  );
}
